export default {
  namespaced: true,
  state: {
    customListMap: {},
    smfList: []
  },
  getters: {
    getCustomListMap: state => state.customListMap,
    getSmfList: state => state.smfList
  },
  mutations: {
    addToCustomListMap (state, { data, id }) {
      state.customListMap = {
        ...state.customListMap,
        [id]: data
      }
    },
    appendToCustomListMap (state, data) {
      state.customListMap = { ...state.customListMap, ...data }
    },
    setSmfList (state, data) {
      state.smfList = data
    },

    clearCustomListMap (state, action) {
      state.customListMap = {}
    }
  }
}
